import { render, staticRenderFns } from "./DatePicker2.vue?vue&type=template&id=72a55cb1&"
import script from "./DatePicker2.vue?vue&type=script&lang=ts&"
export * from "./DatePicker2.vue?vue&type=script&lang=ts&"
import style0 from "./DatePicker2.vue?vue&type=style&index=0&id=72a55cb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports